export default __webpack_public_path__ + "static/media/CNo.68-1.56160f7c.jpg";